import { ChallengeRules } from '../types';
import { calcPoints } from '../utils/points';
import { fmtDuration } from '../utils/format';

/** Examples of points at 25%, 50% and 100% of the minimum stay. */
export function EarningsScale({ rules }: { rules: ChallengeRules }) {
  const { minStayMinutes } = rules;
  if (!minStayMinutes) return null;

  const marks = [0.25, 0.5, 1].map((ratio) => {
    const minutes = minStayMinutes * ratio;
    return {
      ratio,
      label:
        ratio < 1 ? fmtDuration(minutes) : `${fmtDuration(minutes)} ou mais`,
      points: calcPoints(minutes, rules),
    };
  });

  return (
    <section className="pv-card pv-earnings" aria-label="Quanto você ganha">
      <div className="pv-earnings__head">
        <h2 className="pv-h3">Quanto você ganha</h2>
        <span className="pv-muted pv-small">
          mínimo de {fmtDuration(minStayMinutes)}
        </span>
      </div>

      <div className="pv-earnings__tiles">
        {marks.map((mark) => (
          <div
            key={mark.ratio}
            className={`pv-earnings__tile${mark.ratio === 1 ? ' is-full' : ''}`}
          >
            <div className="pv-small">{mark.label}</div>
            <strong>{Math.round(mark.ratio * 100)}%</strong>
            <div className="pv-small">{mark.points} pts</div>
          </div>
        ))}
      </div>

      <p className="pv-muted pv-small">
        Os pontos são proporcionais ao tempo entre a entrada e a saída,
        arredondados para cima.
      </p>
    </section>
  );
}
